import queryString from "query-string";
import { createRouter, createWebHistory, RouterView } from "vue-router";
import type { Router } from "vue-router";

const router: Router = createRouter({ history: createWebHistory(), routes: [] });

// 首页
router.addRoute({
  path: "/",
  name: "/",
  component: async () => await import("../views/index.vue"),
  meta: { title: "飞鱼科技" },
});

if (import.meta.env.VITE_SDK_ENV === "direct") {
  // 网页直充
  router.addRoute({
    path: "/direct",
    name: "/direct",
    component: async () => {
      return await import("../views/payment/index.vue");
    },
    children: [
      // 网页直充-桌面端
      {
        path: "/:appId(\\d+)",
        name: "/appId",
        component: async () => {
          return await import("../views/payment/direct-desktop/index.vue");
        },
        meta: { title: "飞鱼充值中心" },
      },
      // 网页直充-移动端
      {
        path: "/m/:appId(\\d+)",
        name: "/m/appId",
        component: async () => {
          return await import("../views/payment/direct-mobile/index.vue");
        },
        meta: { title: "飞鱼充值中心" },
      },
    ],
  });

  // 微信小游戏
  router.addRoute({
    path: "/wechat",
    name: "/wechat",
    component: async () => {
      return await import("../views/payment/index.vue");
    },
    children: [
      // 微信小游戏-客服支付
      {
        path: "/wechat-mini-game",
        name: "/wechat-mini-game",
        component: async () => {
          return await import("../views/payment/wechat-mini-game/index.vue");
        },
        meta: { title: "游戏物品兑换" },
      },
    ],
  });
}

if (import.meta.env.VITE_SDK_ENV === "account") {
  // 账号管理
  router.addRoute({
    path: "/account",
    name: "/account",
    component: async () => {
      return await import("../views/account/index.vue");
    },
    children: [
      // 账号注销
      {
        path: "/app/deactivate",
        name: "/app/deactivate",
        component: async () => {
          return await import("../views/account/app-deactivate/index.vue");
        },
        meta: { title: "账号注销" },
      },
      // 实名认证问题
      {
        path: "/app/faq-health",
        name: "/app/faq-health",
        component: async () => {
          return await import("../views/account/app-faq-health/index.vue");
        },
        meta: { title: "实名认证问题" },
      },
      // 游戏账号注销
      {
        path: "/app/game-deactivate",
        name: "/app/game-deactivate",
        component: async () => {
          return await import("../views/account/app-game-deactivate/index.vue");
        },
        meta: { title: "游戏账号注销" },
      },
      // 悬浮球-首页
      {
        path: "/home",
        name: "/home",
        component: async () => {
          return await import("../views/account/home/index.vue");
        },
        meta: { title: "首页" },
      },
      // 悬浮球-首页
      {
        path: "/home/:appId(\\d+)",
        name: "/home/appId",
        component: async () => {
          return await import("../views/account/home-index/index.vue");
        },
        meta: { title: "首页" },
      },
      // 悬浮球-资讯
      {
        path: "/home/news/:newsId",
        name: "/home/news/newsId",
        component: async () => {
          return await import("../views/account/home-news-index/index.vue");
        },
        meta: { title: "资讯" },
      },
      // 悬浮球-资讯-概览
      {
        path: "/home/news-overview/:newsId",
        name: "/home/news-overview/newsId",
        component: async () => {
          return await import("../views/account/home-news-overview/index.vue");
        },
        meta: { title: "资讯" },
      },
      // 悬浮球-外部链接
      {
        path: "/home/webview",
        name: "/home/webview",
        component: async () => {
          return await import("../views/account/home-webview/index.vue");
        },
        meta: { title: "外部链接" },
      },
    ],
  });

  // 账号协议
  router.addRoute({
    path: "/protocol",
    name: "/protocol",
    component: async () => {
      return await import("../views/account/index.vue");
    },
    children: [
      // 账号注销协议
      {
        path: "/protocol/deactivate",
        name: "/protocol/deactivate",
        component: async () => {
          return await import("../views/account/protocol-deactivate/index.vue");
        },
        meta: { title: "账号注销协议" },
      },
      // 游戏账号注销协议
      {
        path: "/protocol/game-deactivate",
        name: "/protocol/game-deactivate",
        component: async () => {
          return await import("../views/account/protocol-game-deactivate/index.vue");
        },
        meta: { title: "游戏账号注销协议" },
      },
      // 账号隐私协议
      {
        path: "/protocol/privacy",
        name: "/protocol/privacy",
        component: async () => {
          return await import("../views/account/protocol-privacy/index.vue");
        },
        meta: { title: "飞鱼科技隐私条款" },
      },
      // 账号服务条款
      {
        path: "/protocol/service",
        name: "/protocol/service",
        component: async () => {
          return await import("../views/account/protocol-service/index.vue");
        },
        meta: { title: "飞鱼科技用户协议" },
      },
      // 星云SDK儿童个人信息保护规则
      {
        path: "/protocol/nebula-privacy-child",
        name: "/protocol/nebula-privacy-child",
        component: async () => {
          return await import("../views/account/protocol-nebula-privacy-child/index.vue");
        },
        meta: { title: "星云SDK儿童个人信息保护规则" },
      },
      // 星云SDK隐私保护指引
      {
        path: "/protocol/nebula-privacy-sdk",
        name: "/protocol/nebula-privacy-sdk",
        component: async () => {
          return await import("../views/account/protocol-nebula-privacy-sdk/index.vue");
        },
        meta: { title: "飞鱼科技星云SDK隐私保护指引" },
      },
      // 合规指南
      {
        path: "/protocol/compliance",
        name: "/protocol/compliance",
        component: async () => {
          return await import("../views/account/protocol-compliance/index.vue");
        },
        meta: { title: "合规指南" },
      },
    ],
  });

  // 旧版兼容
  router.addRoute({
    path: "/legacy",
    name: "/legacy",
    component: RouterView,
    children: [
      {
        path: "/account-cancel",
        name: "/account-cancel",
        redirect: "/app/deactivate",
      },
      {
        path: "/game-cancel",
        name: "/game-cancel",
        redirect: "/app/game-deactivate",
      },
      {
        path: "/clause-cancel",
        name: "/clause-cancel",
        redirect: "/protocol/deactivate",
      },
      {
        path: "/clause-game-cancel",
        name: "/clause-game-cancel",
        redirect: "/protocol/game-deactivate",
      },
      {
        path: "/clause-privacy",
        name: "/clause-privacy",
        redirect: "/protocol/privacy",
      },
      {
        path: "/clause-service",
        name: "/clause-service",
        redirect: "/protocol/service",
      },
      {
        path: "/nebula-privacy-child",
        name: "/nebula-privacy-child",
        redirect: "/protocol/nebula-privacy-child",
      },
      {
        path: "/nebula-privacy-sdk",
        name: "/nebula-privacy-sdk",
        redirect: "/protocol/nebula-privacy-sdk",
      },
      {
        path: "/nebula-faq-heath",
        name: "/nebula-faq-heath",
        redirect: "/app/faq-health",
      },
      {
        path: "/compliance",
        name: "/compliance",
        redirect: "/protocol/compliance",
      },
    ],
  });
}

router.beforeEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title as string;
  }
});

Object.defineProperty(router, "open", {
  enumerable: true,
  get: () => {
    return (options) => {
      const { url, query } = queryString.parseUrl(options.path);
      window.open(
        [
          location.origin,
          url,
          "?",
          queryString.stringify({ ...query, ...options.query }, { skipNull: true }),
        ].join(""),
      );
    };
  },
});

export default router;
